module.exports = __webpack_public_path__ + "img/about/80243-018-1.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-018-1.png
// module id = 15
// module chunks = 0